import merge from 'lodash/merge';
import Message from './Message';
import ValidationRule from './ValidationRule';
import { createObjectWithPath, isFunc } from '@/utils/commonUtils';
import { replaceAll } from '@/utils/stringUtils';

export default class BaseValidation {
  messages: Message[] = [];
  rules: object = {};
  model: object = {};
  path: string;
  key?: string;

  get pathWithDot() {
    return this.path ? `${this.path}.` : '';
  }

  constructor(validations: ValidationRule[], path: string = '', key: string = '') {
    if (!path && path !== '') {
      throw new Error('Empty validation path should be empty string');
    }

    this.path = path;
    this.key = key;

    validations.forEach((r) => this.addRule(r));
  }

  addModel(name: string, value?: any) {
    (this.model as any)[name] = value === undefined ? '' : value;
  }

  addRule(rule: ValidationRule) {
    const { name, rules, messages } = rule;

    this.addModel(name, rule.modelValue);

    (this.rules as any)[name] = merge((this.rules as any)[name], rules);

    this.messages = [
      ...this.messages,
      ...Object.keys(messages).map((key: string) => {
        const message = (messages as any)[key];

        return {
          key: `${this.pathWithDot}${name}`,
          rule: key,
          message: message,
          messageFunc: isFunc(message) ? message : undefined,
        };
      }),
    ];
  }

  changeRule(rule: ValidationRule) {}

  static getMessages(validations: BaseValidation[]) {
    return validations.reduce(
      (result: Message[], current: BaseValidation) => [...result, ...current.messages],
      [],
    ) as Message[];
  }

  static getModel(validations: BaseValidation[]) {
    return merge({}, ...validations.map((v) => createObjectWithPath(`${v.path}`, v.model)));
  }

  static getRules(validations: BaseValidation[]) {
    return {
      model: merge(
        {},
        ...validations.map((v) => {
          if (v.path.includes('[]')) {
            const rules: any = v.rules;
            if (v.key) {
              rules['$trackBy'] = v.key;
            }
          }
          const rules = createObjectWithPath(`${replaceAll(v.path, '[]', '.$each')}`, v.rules);
          return rules;
        }),
      ),
    };
  }
}
